import { render } from "./CheckboxSingle.vue?vue&type=template&id=52e9aa9e&scoped=true"
import script from "./CheckboxSingle.vue?vue&type=script&lang=js"
export * from "./CheckboxSingle.vue?vue&type=script&lang=js"

import "./CheckboxSingle.vue?vue&type=style&index=0&id=52e9aa9e&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e9aa9e"]])

export default __exports__